/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Pribyl (pribyl@cadwork.cz)
 *
 */

export default
class Container {
    private _objects: {} = {};

    constructor() {
    }

    public fill(aObjects: {}): void {
        this._objects = {};

        for (let key in aObjects) {
            this._objects[key] = aObjects[key];
        }
    }

    public add(aName: string, aObject: any) {
        this._objects[aName] = aObject;
        return this._objects[aName];
    }

    public get(aName: string): any {
        return this._objects[aName];
    }

    public getObjects(): {} {
        return this._objects;
    }

    public remove(aName: string): boolean {
        if (this._objects[aName] === "undefined)") {
            return false;
        }

        delete this._objects[aName];

        return true;
    }

    public removeAll(): void {
        this._objects = {};
    }

    public forEach(aMethod: string, aArgs?: any) {
        for (let key in this._objects) {
            if (this._objects[key][aMethod] !== undefined) {
                this._objects[key][aMethod].apply(this._objects[key], aArgs);
            }
        }
    }

    public callForEachItem(aMethod: any) {
        for (let key in this._objects) {
            if (!aMethod(this._objects[key])) {
                break;
            }
        }
    }
}

